export const actionType = {

    NOTIFICATION_REQUEST: 'NOTIFICATION_REQUEST',
    NOTIFICATION_SUCCESS: 'NOTIFICATION_SUCCESS',
    NOTIFICATION_FAILURE: 'NOTIFICATION_FAILURE', 

    UPDATE_NOTIFICATION_SUCCESS : 'UPDATE_NOTIFICATION_SUCCESS'
  
};